import { render } from "./AccountView.vue?vue&type=template&id=4ff876d0"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"
script.render = render

export default script